import { render, staticRenderFns } from "./ListRooms.vue?vue&type=template&id=47215efc&"
import script from "./ListRooms.vue?vue&type=script&lang=js&"
export * from "./ListRooms.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports